import React, { useState, useEffect, useRef } from 'react';
import Panel from '../layout/Panel';
import SearchField from '../layout/SearchField';
import Spacer from '../layout/Spacer';
import ListView from '../listComponent/ListView';
import ListItem from '../listComponent/ListItem';
import Button from '../layout/Button';
import Scenario from '../../classes/scenarioElements/Scenario';
import TextUtils from '../../classes/utilities/TextUtils';
import Sequence from '../../classes/scenarioElements/Sequence';
import { getUuidv4 } from '../../classes/utilities/Misc';

export default function StepPicker(props: {
	value: string,
	onSelectedCallback?: (stepId: string) => void,
	onShutdown?: () => void,
	filterCps?: boolean,
})
{
	const [selectedObjectId, setSelectedObjectId] = useState(props.value);
	const [searchQuery, setSearchQuery] = useState("");

	const selfRef = useRef(null);
	const guid = useRef(getUuidv4());
	const previouslyFocused = useRef(document.activeElement as HTMLElement);

	useEffect(() =>
	{
		if (selfRef.current)
		{
			// document.getElementById(guid.current).focus();
			//For some reason it doesn't focus when done here, so delay it to the next event loop cycle...
			const o = document.getElementById(guid.current);
			setTimeout(() =>{o?.focus();}, 0);
		}

		return ()=>
		{
			if (previouslyFocused.current)
			{
				previouslyFocused.current.focus();
			}
		}

	}, [selfRef.current]);

	function renderSteps(sequence: Sequence)
	{
		const output = new Array<React.ReactElement>();

		for(const step of sequence.steps)
		{
			if(step.isDisabledTrackersStep() || step.isTrackersStep() || !TextUtils.searchString(step.name, searchQuery)) continue;
			if(props.filterCps && step.isTrackersStep()) continue;

			output.push(
				<ListItem
					key={step.id}
					nodeId={step.id}
					label={step.name}
					parent={sequence.id}
				/>
			);
		}

		return output;
	}

	function renderSequences()
	{
		const output = new Array<React.ReactElement>();
		
		for(const sequence of Scenario.getSequences())
		{
			const stepItems = renderSteps(sequence);
			if(stepItems.length)
			{
				output.push(
					<ListItem
						key={sequence.id}
						nodeId={sequence.id}
						label={sequence.name}
						parent={null}
						isSelectable={false}
					>
						{
							stepItems
						}
					</ListItem>
				);
			}
		}

		return output;
	}

	function onObjectSelected(selectedItem)
	{
		const value = selectedItem.values().next().value;
		if (value)
		{
			setSelectedObjectId(value.nodeId);
		}
		else
		{
			setSelectedObjectId("");
		}
	}

	function onStepPicked()
	{
		if (props.onSelectedCallback)
		{
			props.onSelectedCallback(selectedObjectId);
		}

		if (props.onShutdown)
		{
			props.onShutdown();
		}
	}

	return (
		<Panel className="solid composite"
			ref={selfRef}
			style={{
				maxHeight: "500px",
				maxWidth: "500px",
			}}
		>
			<SearchField
				id={guid.current}
				value={searchQuery}
				onChangeCallback={(v) => setSearchQuery(v)}
				autoFocus={true}
			/>
			<Spacer size={{ y: "2px" }} />
			<ListView
				selectedItems={new Set().add(selectedObjectId)}
				selectionChangedCallback={onObjectSelected}
				multiSelectEnabled={false}
				doubleClickCallback={onStepPicked}
				expandSelected={true}
				dndDefaults={{
					dragEnabled: false,
					dropEnabled: false,
				}}
			>
				<ListItem
					key={"none"}
					nodeId={null}
					label={" - None - "}
					parent={null}
				/>
				{
					renderSequences()
				}
			</ListView>
			<Button
				silent={true}
				label="Confirm"
				onClick={onStepPicked}
			/>
		</Panel>
	);
}